import React from "react";
import { Container, Row, Col, Card } from "reactstrap";
import { Target } from "lucide-react";

function TheBiggerVisionSection() {
    const size =
        document.body.clientWidth >= 928 || document.documentElement.clientWidth >= 928;

    return (
        <section
            className="section py-5"
            style={{ background: "transparent", position: "relative", zIndex: 1 }}
        >
            <Container>
                <Row className="justify-content-center">
                    <Col lg={10} xl={8}>
                        <Card
                            style={{
                                background: "rgba(255, 255, 255, 0.04)",
                                backdropFilter: "blur(12px)",
                                border: "1px solid rgba(107, 186, 194, 0.25)",
                                borderRadius: "20px",
                                padding: size ? "2.5rem" : "1.75rem",
                                overflow: "hidden",
                                position: "relative",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    gap: "1.25rem",
                                    marginBottom: "1.5rem",
                                }}
                            >
                                <div
                                    style={{
                                        width: size ? 56 : 50,
                                        height: size ? 56 : 50,
                                        minWidth: size ? 56 : 50,
                                        borderRadius: "16px",
                                        background: "linear-gradient(145deg, rgba(107, 186, 194, 0.25), rgba(191, 190, 40, 0.15))",
                                        border: "2px solid rgba(107, 186, 194, 0.5)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Target size={size ? 28 : 24} strokeWidth={2} style={{ color: "#6bbac2" }} />
                                </div>
                                <h2
                                    className="text-white mb-0"
                                    style={{
                                        fontSize: size ? "2rem" : "1.6rem",
                                        fontWeight: 700,
                                        letterSpacing: "0.04em",
                                        textTransform: "uppercase",
                                        color: "#6bbac2",
                                        lineHeight: "1.2",
                                    }}
                                >
                                    The Bigger Vision
                                </h2>
                            </div>
                            <p
                                className="text-white mb-4"
                                style={{
                                    fontSize: size ? "1.2rem" : "1.05rem",
                                    lineHeight: "1.8",
                                    opacity: 0.95,
                                }}
                            >
                                The ANZ Digital Twin 2026 aims to accelerate a dynamic,
                                standards-aligned and investable digital twin ecosystem across the
                                ANZ region.
                            </p>
                            <p
                                className="text-white mb-0"
                                style={{
                                    fontSize: size ? "1.2rem" : "1.05rem",
                                    lineHeight: "1.8",
                                    opacity: 0.95,
                                }}
                            >
                                By bringing together infrastructure, climate, planning and digital
                                leaders, the event turns digital twin ambition into tangible
                                outcomes — for communities, climate resilience and the economy.
                            </p>
                            <div
                                style={{
                                    position: "absolute",
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    height: "4px",
                                    background: "linear-gradient(90deg, #6bbac2, #bfbe28)",
                                    opacity: 0.7,
                                }}
                            />
                        </Card>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default TheBiggerVisionSection;
